import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Preloader from './Preloader';

interface RouteTransitionProps {
  children: React.ReactNode;
}

const RouteTransition: React.FC<RouteTransitionProps> = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [isLoading, setIsLoading] = useState(false);
  const [shouldRenderChildren, setShouldRenderChildren] = useState(true);

  useEffect(() => {
    if (location !== displayLocation) {
      setIsLoading(true);
      setShouldRenderChildren(false);
      
      // Wait for fade in
      setTimeout(() => {
        setDisplayLocation(location);
        setShouldRenderChildren(true);
        
        // Wait for content to update and fade out
        setTimeout(() => {
          setIsLoading(false);
        }, 400);
      }, 400);
    }
  }, [location, displayLocation]);

  return (
    <>
      <Preloader isLoading={isLoading} />
      {shouldRenderChildren && children}
    </>
  );
};

export default RouteTransition; 